var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10"},[(_vm.loading)?_c('LoadingAnimation',{attrs:{"full-page":""}}):_vm._e(),_c('PdfGen',{key:'pdf_' + _vm.pdfKey,ref:"pdf",attrs:{"landscape":"","invisible":"","page-size":"A3","header-data":_vm.pdfHeader,"content-data":_vm.pdfData,"name":_vm.localStorage.translations.pages.planning.pages['obem-zakazov'] +
      ' ' +
      new Date().getDate() +
      '.' +
      (new Date().getMonth() + 1) +
      '.' +
      new Date().getFullYear() +
      '.pdf'}}),_c('BaseButton',{attrs:{"default_icon":"button-create_pdf","round":"","icon_only":""},on:{"click":function($event){return _vm.onPrintPdf()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }